import React, { useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';

import useGlobal from '../../../store';
import RetencionesMasivasFilesList from './list/RetencionesMasivasFilesList';
import SearchByDatesAndKeyword from '../../../shared/SearchByDatesAndKeyword';
import RetencionesMasivasFilesActions from './components/RetencionesMasivasFilesActions';
import RetencionesMasivasFilesItemActions from './components/RetencionesMasivasFilesItemActions';

const mapState = (store) => {
  return store.modulo.retenciones_masivas.files.list;
};

const mapActions = (actions) => {
  return actions.modulo.retenciones_masivas.files.list;
};

const RetencionesMasivasFiles = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  useEffect(() => {
    window.setAppTitle('Retenciones masivas');
  }, []);

  const handleOnRowSelectionChange = ({ selectedRowKeys, selectedRows }) => {
    actions.setSelectedRows({
      selectedRowKeys,
      selectedRows,
    });
  };

  const handleOnRowClick = (data) => {
    props.history.replace({
      pathname: `/modulos/retenciones-masivas/files/${data.id}/info`,
      state: {
        data: { ...data },
      },
    });
  };

  const handleOnDateChange = (event) => {
    paginate({
      to: event.to,
      from: event.from,
    });
  };

  const handleOnKeywordChange = (event) => {
    paginate({ search: event });
  };

  const paginate = (event) => {
    actions.paginate({
      filters: { ...event },
      pagination: { page: 1 },
    });
  };

  const { selectedRowKeys, selectedRows, filters } = state;
  const { search, from, to } = filters;

  return (
    <>
      <Row>
        <Col
          sm="auto"
          md="7"
          className="mb-2"
        >
          {selectedRowKeys.length > 0 && (
            <div className="mr-3 d-inline-flex pb-2">
              <RetencionesMasivasFilesItemActions
                selectedRowKeys={selectedRowKeys}
                selectedRows={selectedRows}
                alignRight={false}
              />
            </div>
          )}

          {selectedRowKeys.length === 0 && (
            <SearchByDatesAndKeyword
              from={from}
              to={to}
              search={search}
              onDateChange={handleOnDateChange}
              onKeywordChange={handleOnKeywordChange}
            />
          )}
        </Col>

        <Col
          sm="auto"
          md="5"
          className="text-right pb-2"
        >
          <RetencionesMasivasFilesActions />
        </Col>
      </Row>

      <RetencionesMasivasFilesList
        onRowClick={handleOnRowClick}
        selectedRowKeys={selectedRowKeys}
        selectedRows={selectedRows}
        onRowSelectionChange={handleOnRowSelectionChange}
      />
    </>
  );
};

export default RetencionesMasivasFiles;
